module.exports = __webpack_public_path__ + "static/media/landing-4.1f3d7cf7.jpg";